<template>
  </template>
  <script>
  import { showNotify, showDialog } from 'vant';
  import Upload from '../../components/upload.vue'
  import UpAction from '../../components/upAction.vue'
  import { mapMutations, mapGetters } from 'vuex'
  import { checkCamera } from '../../utils/checkCamera'
  // 公共方法
  import { riskStatement, getUrlParams } from '../../utils/const'
  // 组件相关校验方法
  export default {
    name: '',
    components: {
        Upload,
        UpAction,
    },
    data() {
        return {
          //   deviceType: '',
            weightErr: false,
            patientInfoData: '', // 身份证认证获取患者信息
            certificateList: [], // 复诊凭证图
            hisCertificateList: [], // 问诊带过来的复诊图
            showPop: false,
            inquiryMode: 0, // 订单类型
            diseaseHistoryList: [
                { name: '青霉素' },
                { name: '阿司匹林' },
                { name: '螨尘' },
                { name: '花粉' },
                { name: '海鲜' },
                { name: '蛋白质（牛奶鸡蛋）' },
            ],
            confirmedDiseaseList: [
                { name: '感冒' },
                { name: '咽炎' },
                { name: '扁桃体炎' },
                { name: '支气管炎' },
                { name: '哮喘' },
                { name: '鼻炎' },
                { name: '牙龈炎' },
                { name: '中耳炎' },
                { name: '消化不良' },
                { name: '腹泻' },
                { name: '痤疮' },
                { name: '湿疹' },
                { name: '尿道炎' },
                { name: '便秘' },
                { name: '结膜炎' },
                { name: '阴道炎' },
                { name: '月经不调' },
                { name: '骨质疏松' },
                { name: '高血压' },
                { name: '低血压' },
                { name: '糖尿病' },
                { name: '痛风' },
                { name: '其他' },
            ],
            confirmDisIndex: '',
            confirmDisVal: '',
            addDisease: '',
            addDialog: false,
            diseaseHistory: {
                allergy: {
                    value: 'no',
                    supplement: '',
                    selectList: '',
                },
                historyMedical: {
                    value: 'no',
                    supplement: '',
                },
                pregnancy: {
                    value: 'no',
                    selectList: '',
                },
                liver: 'no',
                renal: 'no',
            },
            have: 0,
            uploadGroup: [{ uploadValue: '', id: 1, file: null, keyID: '', isDelete: 0 }],
            disabled: false,
            pramas: {
                radio: 'no',
                name: '',
                phone: '',
                id: '',
                patientWeight: '',
            },
            selectParams: {
                radio: 'yes',
            },
            more: false,
            radio: true,
            sureRadio: false,
            sure: true,
            disease: false,
            selectList: [],
            pregnancyList: [
                { name: '妊娠', id: 2 },
                { name: '哺乳', id: 3 },
                { name: '备孕', id: 1 },
            ],
            patientInfo: {
                sex: '男',
                age: '23岁',
            },
            verificationResult: true,
            verificationUniqueID: 0,
            risNotification: false,
            params: {},
            backTag: false,
            idCardErr: false, // 身份证是否有误
            imgList: [],
            isEditPatient: 1,
            loading: false, // 避免重复提交
            token: '',
        }
    },
    computed: {
        age: function () {
            return parseInt(this.patientInfo.age.split('岁')[0])
        },
        riskStatement: () => riskStatement,
        ...mapGetters(['userInfo', 'orderDetail', 'urlParams', 'deviceType', 'endInquiry', 'huafuUI']),
    },
    created() {
        this.token = this.$route.query.token
        this.getSdkAppId()
    },
    mounted() {
        this.getUrlParams()
        this.cacheMapper()
  
        this.$bus.on('naviBack', () => {
            this.backTag = true
        })
        const { deviceType, bizID, clientID, timestamp, sign } = this.$route.query
        if (deviceType == 'alipay') {
            this.isEditPatient = 0
        }
        const endInquiry = {
            bizID,
            clientID,
            timestamp,
            sign,
            deviceType,
        }
  
        this['global/updateEndInquiry'](endInquiry)
        this['global/updateDeviceType'](deviceType)
        this.$bus.on('updateSuccess', (item) => {
            let find = false
            for (let i = 0; i < this.imgList.length; i++) {
                if (this.imgList[i].id === item.id) {
                    this.imgList[i].flag = true
                    find = true
                    break
                }
            }
            if (!find) {
                this.imgList.push(item)
            }
        })
    },
    methods: {
        getSdkAppId() {
            const params = {
                token: this.token,
            }
            this.$_http.get(this.$_API.H5_INQUIRY_GET_SDKAPPID, { params }).then((res) => {
                const { appID } = res.data
                window.sessionStorage.setItem('appID', appID)
            })
        },
        // 身份证认证
        idCardVerification(personName, idNo) {
            let that = this
            let personInfo = {
                personName: personName,
                idNo: idNo,
            }
            this.$_http
                .post(this.$_API.H5_INQUIRY_CENTER_ID_CARD_VERI, personInfo)
                .then((res) => {
                    if (res.success) {
                        this.patientInfoData = res.data
                        this.idCardErr = false
                    } else {
                        this.idCardErr = true
                    }
                })
                .catch((err) => {
                    that.idCardErr = true
                    console.log('错误？', err, that.idCardErr)
                })
        },
  
        // 提交申请单
        commitOrder() {
            if (this.loading) return
            const historyOfSickness = this.diseaseHistory.historyMedical.value === 'yes' ? 1 : 0
            if (historyOfSickness === 1 && !this.diseaseHistory.historyMedical.supplement) {
                showNotify({
                    type: 'warning',
                    message: '请补充既往病史',
                    duration: 1000,
                })
                this.disease = true
                return false
            }
            const historyOfAllergy = this.diseaseHistory.allergy.value === 'yes' ? 1 : 0
            let allergyDetail = []
            for (let i of this.diseaseHistoryList) {
                if (i.checked) {
                    allergyDetail.push(i.name)
                }
            }
            allergyDetail = allergyDetail.toString()
            if (allergyDetail) {
                allergyDetail = this.diseaseHistory.allergy.supplement
                    ? allergyDetail + ',' + this.diseaseHistory.allergy.supplement
                    : allergyDetail
            } else {
                allergyDetail = this.diseaseHistory.allergy.supplement
            }
            if (historyOfAllergy === 1 && !allergyDetail) {
                showNotify({
                    type: 'warning',
                    message: '请选择或补充过敏史',
                    duration: 1000,
                })
                return false
            }
            let params = {
                inquiryOrderID: this.params.inquiryOrderID,
                bizID: this.params.bizID,
                isReviewInquiry: this.selectParams.radio === 'yes' ? 1 : 0,
                clientAppID: this.params.clientAppID,
                clientID: this.params.clientID,
                inquiryType: this.params.inquiryType,
                providerID: this.params.providerID,
                providerName: this.params.providerName,
                remoteInquiryOrderID: this.params.remoteInquiryOrderID,
            }
            const liver = this.diseaseHistory.liver === 'yes' ? 1 : 0
            const renal = this.diseaseHistory.renal === 'yes' ? 1 : 0
            let pregnancy = ''
            for (let i of this.pregnancyList) {
                if (i.checked) {
                    pregnancy = i.id
                }
            }
            const keyID = this.params.patientInfo ? this.params.patientInfo.keyID : ''
            // const patientIdNoType = this.params.patientInfo ? this.params.patientInfo.patientIdNoType : ''
            pregnancy = pregnancy === '' ? 0 : pregnancy
            params.patientInfo = {
                allergyDetail: allergyDetail,
                historyOfAllergy: historyOfAllergy,
                historyOfSickness: historyOfSickness,
                illDesc: this.confirmDisVal,
                keyID: keyID,
                liver: liver,
                orderID: this.params.inquiryOrderID,
                patientAge: this.patientInfoData.age,
                patientIdNo: this.pramas.id,
                patientIdNoType: 0,
                patientName: this.pramas.name,
                patientPhone: this.pramas.phone,
                patientSex: this.patientInfoData.sex,
                patientWeight: this.pramas.patientWeight === 'undefined' ? 0.0 : this.pramas.patientWeight,
                pregnancy: pregnancy,
                renal: renal,
                sicknessDetail: this.diseaseHistory.historyMedical.supplement,
            }
            this.certificateList = []
            for (let i of this.uploadGroup) {
                if (i.uploadValue) {
                    this.certificateList.push({ keyID: i.keyID, certificateUrl: i.uploadValue, isDelete: i.isDelete })
                }
            }
            params.certificateList = [...this.certificateList, ...this.hisCertificateList]
            this.loading = true
            this.$_http.post(this.$_API.H5_INQUIRY_CENTER_ORDER_COMMIT, params).then((res) => {
                this.loading = false
                if (res.success) {
                    this['user/updateImInfo']({ ...res.data })
                    this['global/updateStep'](1)
                    this.$router.replace({
                        path: '/waiting',
                        query: {
                            ...this.urlParams,
                        },
                    })
                }
            })
        },
        // 将cache信息映射
        cacheMapper() {
            this.params = this.userInfo
            delete this.params.orderStatus
            if (!this.userInfo.patientInfo) return
            this.pramas.name = this.userInfo.patientInfo.patientName || ''
            this.pramas.id = this.userInfo.patientInfo.patientIdNo || ''
            this.pramas.phone = this.userInfo.patientInfo.patientPhone || ''
            if (this.userInfo.patientInfo.patientPhone) {
                this.verificationPhone()
            }
            this.pramas.patientWeight = this.userInfo.patientInfo.patientWeight + ''
            // this.userInfo.indications.forEach(selectListItem => {
            //   this.selectList.push({ name: selectListItem })
            // })
            this.getAge()
            // 过敏史
            if (this.userInfo.patientInfo.historyOfAllergy === 1 || this.userInfo.patientInfo.historyOfAllergy === '1') {
                this.pramas.radio = 'yes'
                this.diseaseHistory.allergy.value = 'yes'
                let str = ''
                let first = true
                let arr = this.userInfo.patientInfo.allergyDetail.split(',')
                arr.forEach((item) => {
                    let flag = false
                    this.diseaseHistoryList.forEach((element) => {
                        if (element.name === item) {
                            flag = true
                            item.checked = true
                        }
                    })
                    if (!flag) {
                        if (!first) {
                            str += ','
                        }
                        str += item
                    }
                })
                this.diseaseHistory.allergy.supplement = str
            }
            // 过往病史
            if (this.userInfo.patientInfo.historyOfSickness === 1 || this.userInfo.patientInfo.historyOfSickness === '1') {
                this.pramas.radio = 'yes'
                this.diseaseHistory.historyMedical.value = 'yes'
                this.diseaseHistory.historyMedical.supplement = this.userInfo.patientInfo.sicknessDetail
            }
            // 备孕
            switch (this.userInfo.patientInfo.pregnancy) {
                case 2:
                    this.pregnancyList.forEach((item) => {
                        if (item.name === '妊娠') {
                            item.checked = true
                        }
                    })
                    this.pramas.radio = 'yes'
                    this.diseaseHistory.pregnancy.value = 'yes'
                    break
                case '2':
                    this.pregnancyList.forEach((item) => {
                        if (item.name === '妊娠') {
                            item.checked = true
                        }
                    })
                    this.pramas.radio = 'yes'
                    this.diseaseHistory.pregnancy.value = 'yes'
                    break
                case 3:
                    this.pregnancyList.forEach((item) => {
                        if (item.name === '哺乳') {
                            item.checked = true
                        }
                    })
                    this.pramas.radio = 'yes'
                    this.diseaseHistory.pregnancy.value = 'yes'
                    break
                case '3':
                    this.pregnancyList.forEach((item) => {
                        if (item.name === '哺乳') {
                            item.checked = true
                        }
                    })
                    this.pramas.radio = 'yes'
                    this.diseaseHistory.pregnancy.value = 'yes'
                    break
                case 1:
                    this.pregnancyList.forEach((item) => {
                        if (item.name === '备孕') {
                            item.checked = true
                        }
                    })
                    this.pramas.radio = 'yes'
                    this.diseaseHistory.pregnancy.value = 'yes'
                    break
                case '1':
                    this.pregnancyList.forEach((item) => {
                        if (item.name === '备孕') {
                            item.checked = true
                        }
                    })
                    this.pramas.radio = 'yes'
                    this.diseaseHistory.pregnancy.value = 'yes'
                    break
                default:
                    break
            }
            // 肝
            if (this.userInfo.patientInfo.liver === 1 || this.userInfo.patientInfo.liver === '1') {
                this.pramas.radio = 'yes'
                this.diseaseHistory.liver = 'yes'
            }
            // 肾功能
            if (this.userInfo.patientInfo.renal === 1 || this.userInfo.patientInfo.renal === '1') {
                this.pramas.radio = 'yes'
                this.diseaseHistory.renal = 'yes'
            }
            this.isEditPatient = this.userInfo.isEditPatient
            this.inquiryMode = this.userInfo.inquiryMode != null ? Number(this.userInfo.inquiryMode) : 0
            if (this.userInfo.patientInfo && this.userInfo.patientInfo.illDesc) {
                const getIllDesc = this.userInfo.patientInfo.illDesc
                if (getIllDesc) {
                    // 主诉
                    this.confirmedDiseaseList.forEach((item, index) => {
                        if (item.name === getIllDesc) {
                            this.confirmDisIndex = index
                            this.confirmDisVal = getIllDesc
                        }
                    })
                }
            }
            const getCertificateList = this.userInfo.certificateList
            if (getCertificateList && getCertificateList.length > 0) {
                for (let i of getCertificateList) {
                    this.uploadGroup.unshift({
                        uploadValue: i.certificateUrl,
                        id: parseInt(Math.random() * 10000),
                        file: null,
                        keyID: i.keyID,
                        isDelete: i.isDelete,
                    })
                }
            }
            if (this.userInfo.patientInfo) {
                if (this.userInfo.patientInfo.patientName && this.userInfo.patientInfo.patientIdNo) {
                    this.idCardVerification(this.userInfo.patientInfo.patientName, this.userInfo.patientInfo.patientIdNo)
                }
            }
            if (this.userInfo.inquiryType !== 1) {
                checkCamera(() => {})
            }
            setTimeout(() => {
                this.submit();
            }, 200)
        },
        // 获取当前时间减去身份证生日，得到年龄
        getAge() {
            if (!this.pramas.id) return false
            let str =
                this.userInfo.patientInfo.patientIdNo.substr(6, 4) +
                '-' +
                this.userInfo.patientInfo.patientIdNo.substr(10, 2) +
                '-' +
                this.userInfo.patientInfo.patientIdNo.substr(12, 2)
            let time = new Date().getTime() - new Date(str).getTime()
            let age = parseInt(time / 1000 / 60 / 60 / 24 / 365)
            this.patientInfo.age = age + '岁'

            let sexStr = this.userInfo.patientInfo.patientIdNo.substr(this.userInfo.patientInfo.patientIdNo.length - 2, 1)
            if (sexStr % 2 === 0) {
                this.patientInfo.sex = '女'
            } else {
                this.patientInfo.sex = '男'
            }
        },
        // 校验手机号
        verificationPhone() {
            let reg = /^1[3456789]\d{9}$/
            if (!reg.test(this.pramas.phone)) {
                showNotify({
                    type: 'warning',
                    message: '手机号码输入不正确',
                    duration: 1000,
                })
                return false
            }
            return true
        },
        // 提交按钮，校验是否勾选同意《互联网诊疗风险告知书》
        submit() {
            if (this.loading) return
            let loading = false
            if (this.imgList) {
                this.imgList.map((item) => {
                    if (!item.flag) {
                        showDialog({
                            message: '请等待复诊凭证上传成功再提交',
                            confirmButtonText: '确定',
                            confirmButtonColor: '#438BEF',
                            closeOnClickOverlay: true,
                        })
                        loading = true
                    }
                })
            }
            if (loading) return
            if (!this.verificationPhone()) return
            this.idCardVerification(this.pramas.name, this.pramas.id)
            if (this.idCardErr) {
                showDialog({
                    message: '请填写正确的身份证号',
                    confirmButtonText: '确定',
                    confirmButtonColor: '#438BEF',
                    closeOnClickOverlay: true,
                })
                return false
            }
            if (this.patientInfoData.age <= 6) {
                if (this.weightErr) {
                    showDialog({
                        message: '请填写正确的体重值',
                        confirmButtonText: '确定',
                        confirmButtonColor: '#438BEF',
                        closeOnClickOverlay: true,
                    })
                    return false
                }
            }
            if (!this.confirmDisVal) {
                showDialog({
                    message: '请选择已确诊的疾病',
                    confirmButtonText: '确定',
                    confirmButtonColor: '#438BEF',
                    closeOnClickOverlay: true,
                })
                return false
            }
            if (!this.selectParams.radio) {
                showDialog({
                    message: '请确认该病情是否已到线下医院就诊',
                    confirmButtonText: '确定',
                    confirmButtonColor: '#438BEF',
                    closeOnClickOverlay: true,
                })
                return false
            }
            if (!this.sure) {
                showDialog({
                    message: '请勾选互联网诊疗风险告知及知情同意书',
                    confirmButtonText: '确定',
                    confirmButtonColor: '#438BEF',
                    closeOnClickOverlay: true,
                })
                return false
            }
            this.commitOrder()
        },
        routerPush(data) {
            this['user/updateUserInfo']({
                orderStatus: data.orderStatus,
                ...this.params,
            })
            this.cacheMapper()
            if (data.inquiryStatus === 1) {
                this.$router.replace({
                    path: '/waiting',
                    query: {
                        ...this.urlParams,
                    },
                })
            } else if (data.inquiryStatus === 2 || data.inquiryStatus === 3 || data.inquiryStatus === 4) {
                if (data.inquiryType === 1) {
                    this.$router.replace({
                        path: '/consultation',
                        query: {
                            ...this.urlParams,
                        },
                    })
                }
                if (data.inquiryType === 2) {
                    this.$router.replace({
                        path: '/trtcCalling',
                        query: {
                            ...this.urlParams,
                        },
                    })
                }
                if (data.inquiryType === 3) {
                    this.$router.replace({
                        path: '/videoPage',
                        query: {
                            ...this.urlParams,
                        },
                    })
                }
            } else {
                showDialog({
                    message: '订单已取消，请退出重试',
                    confirmButtonText: '确定',
                    confirmButtonColor: '#438BEF',
                    closeOnClickOverlay: true,
                })
            }
        },
        getUrlParams() {
            if (this.$route.name === 'rpViewer') return
            let obj = this.$route.query
            if (!obj['orderID'] || !obj['token']) {
                showDialog({
                    message: '参数缺失，请重新进入',
                    confirmButtonText: '确定',
                    confirmButtonColor: '#438BEF',
                    closeOnClickOverlay: true,
                })
            }
            this['global/updateUrlParams'](obj)
        },
        ...mapMutations([
            'global/updateMask',
            'global/updateStep',
            'global/updateUrlParams',
            'user/updateOrderDetail',
            'global/updateDeviceType',
            'global/updateEndInquiry',
            'user/updateUserInfo',
            'user/updateImInfo',
        ]),
    },
  }
  </script>
